export interface IFilter {
  assetLevel: number;
  assetName?: string;
}

export interface ISeries {
  name: string;
  data: any[];
  color?: string;
}

export interface IIncomingContributions {
  asset_level: string;
  percent_with_incoming: number;
}

export interface IGiving {
  asset_level: string;
  median_payout: number;
}

export interface IIncomingContributionsResponse {
  avg_percent_with_incoming: number;
  data: IIncomingContributions[];
}

export interface IGivingResponse {
  avg_median_payout: number;
  data: IGiving[];
}

export interface ISelect {
  id: number;
  asset_level: string;
}

export interface IPeerGroupsProps {
  filters: IFilter;
  onChange?: (category: string) => void;
  onChangeFilterId?: (filterId: number) => void;
}

export interface IPeerGroupTabsProps {
  data: any[];
  filters: IFilter;
  currentPeerGroup?: any;
  onChange?: (category: string) => void;
  onChangeFilterId?: (filterId: number) => void;
}

export interface IVisualizationState {
  series: ISeries[];
  title: string;
  loading: boolean;
  filters: IFilter;
  data: any[];
  categories?: string[];
  average?: IPoint[] | any[];
  plotLineNumber?: number;
}

interface IRequestBody {
  action: string;
  request: IRequest;
}

interface IRequest {
  assetLevel: number;
  name?: string;
  monthNumber?: string;
  dateStart?: string;
  dateEnd?: string;
}

interface IPoint {
  y: number;
  name: string;
}

const end_point =
  "https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests";
const trend_end_point =
  "https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/publicindexdata";

export function round(numberToRound: number, precision: number) {
  return numberToRound.toLocaleString(undefined, {
    minimumFractionDigits: 1,
    maximumFractionDigits: precision,
  });
}

export function roundNumber(numberToRound: number, precision: number) {
  return parseFloat(
    numberToRound.toLocaleString(undefined, {
      minimumFractionDigits: 1,
      maximumFractionDigits: precision,
    })
  );
}

export function getPerformanceTrendData(
  requestBody: IRequestBody = { action: "", request: { assetLevel: 0 } }
) {
  return fetch(trend_end_point, {
    method: "POST",
    body: JSON.stringify(requestBody),
  })
    .then((response) => {
      return response.text();
    })
    .then((text) => {
      text = text.replace(/u0026/g, "&");
      text = text.replace(/\\/g, "");
      return JSON.parse(text);
    })
    .then((json) => {
      return json;
    });
}

export function getPeerGroupData(
  requestBody: IRequestBody = { action: "", request: { assetLevel: 0 } }
) {
  return fetch(end_point, { method: "POST", body: JSON.stringify(requestBody) })
    .then((response) => {
      return response.text();
    })
    .then((text) => {
      text = text.replace(/u0026/g, "&");
      text = text.replace(/\\/g, "");
      return JSON.parse(text);
    })
    .then((json) => {
      return json;
    });
}

export function getAssetLevels() {
  const givTrendFilterBody = {
    action: "getAssetLevels",
    request: {
      assetLevel: 0,
      name: "",
      monthNumber: "",
      dateStart: "",
      dateEnd: "",
    },
  };

  return fetch(end_point, {
    method: "POST",
    body: JSON.stringify(givTrendFilterBody),
  })
    .then((response) => {
      return response.text();
    })
    .then((text) => {
      text = text.replace(/u0026/g, "&");
      text = text.replace(/\\/g, "");
      return JSON.parse(text);
    })
    .then((json) => {
      json.push({ id: 0, asset_level: "All Asset Levels" });
      return json;
    });
}

export function getIntroductionText(assetLevel) {
  const givTrendFilterBody = {
    action: "getIntroductionText",
    request: {
      assetLevel,
      name: "",
      monthNumber: "",
      dateStart: "",
      dateEnd: "",
    },
  };

  return fetch(
    "https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests",
    { method: "POST", body: JSON.stringify(givTrendFilterBody) }
  )
    .then((response) => {
      return response.text();
    })
    .then((text) => {
      text = text.replace(/u0026/g, "&");
      text = text.replace(/\\/g, "");
      return JSON.parse(text);
    })
    .then((json) => {
      return json;
    });
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/lib/http.ts